import React from 'react';
import { ReportFilter, FilterRenderingInfo } from '../../report-types';
import { parseStringParamFromRouterProps } from 'util/routing';
import { RouteChildrenProps, RouteComponentProps } from 'react-router';
import { Field } from 'formik';
import { FieldError } from 'components/base/form/errornotice/errornotice';

/**
 * Configure a router param as a text filter, for a report API table.
 *
 * @param name
 * @param label
 * @param routerParamName
 */
export function reportFilterRouterParam(
  name: string,
  label: React.ReactNode,
  routerParamName?: string
): ReportFilter {
  function _parseFromFrontendUrl(
    routeProps: RouteChildrenProps | RouteComponentProps
  ) {
    return parseStringParamFromRouterProps(routeProps, routerParamName ?? name);
  }

  return {
    name,
    label,
    render() {
      return (
        <>
          <Field name={name} type="text" disabled={true} />
          <FieldError name={name} />
        </>
      );
    },
    renderSSR(info: FilterRenderingInfo) {
      return info.value;
    },
    getFormValFromUrlParam(routeProps) {
      const valueFromUrl = _parseFromFrontendUrl(routeProps);
      return valueFromUrl;
    },
    getUrlParamFromFormVal(formValues) {
      return {};
    },
    getBackendFilterFromUrl(routeProps) {
      const valueFromUrl = _parseFromFrontendUrl(routeProps);
      if (valueFromUrl === null) {
        return null;
      }

      const filterName = name;
      return { [filterName]: valueFromUrl };
    },
  };
}
